import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useUser from "@saleor/hooks/useUser";
import { parseQueryString } from "@saleor/utils/urls";
import React from "react";
import { useLocation } from "react-router-dom";

import NewPasswordPage, {
  NewPasswordPageFormData
} from "../components/NewPasswordPage";
import { SetPasswordMutation } from "../mutations";
import { SetPassword } from "../types/SetPassword";
import { NewPasswordUrlQueryParams } from "../urls";

const NewPassword: React.FC = () => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const { loginByToken } = useUser();
  const location = useLocation();

  const params = parseQueryString<NewPasswordUrlQueryParams>(
    location.search.substr(1)
  );

  const handleSetPassword = async (data: SetPassword) => {
    if (data.setPassword.errors.length === 0) {
      loginByToken(
        data.setPassword.token,
        data.setPassword.csrfToken,
        data.setPassword.user
      );
      notify({
        status: "success",
        text: "Successfully changed your password!"
      });
      navigate("/", true);
    }
  };

  return (
    <SetPasswordMutation onCompleted={handleSetPassword}>
      {(setPassword, setPasswordOpts) => {
        const handleSubmit = (data: NewPasswordPageFormData) =>
          setPassword({
            variables: {
              email: params.email,
              password: data.password,
              token: params.token
            }
          });

        return (
          <NewPasswordPage
            errors={setPasswordOpts.data?.setPassword.errors || []}
            disabled={setPasswordOpts.loading}
            onSubmit={handleSubmit}
          />
        );
      }}
    </SetPasswordMutation>
  );
};

NewPassword.displayName = "NewPassword";
export default NewPassword;
